export enum MessageMediumType {
  EMAIL = 'Email',
  SMS = 'SMS',
  PUSH_NOTIFICATION = 'Push Notification',
}
